import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { Location } from "@angular/common";
import { Subject, forkJoin, takeUntil } from "rxjs";
import { AppService } from "src/app/app.service";
 
@Component({
  selector: "app-administration",
  templateUrl: "./administration.component.html",
  styleUrls: ["./administration.component.scss"],
})
export class AdministrationComponent implements OnInit, OnDestroy {
  selectedItem: string = "";
  items = [
    { Name: "Governing Body", Url: "governing-body" },
    { Name: "Chairman Message", Url: "message-of-chairman" },
    { Name: "Message of Principal", Url: "message-of-principal" },
    { Name: "Teaching staff", Url: "teacher-information" },
    { Name: "Non Teaching Staff", Url: "staff-information" },
    { Name: "Vice-Chairman", Url: "vice-chairman" },
    { Name: "Vice-Principal", Url: "vice-principal" },
    { Name: "Ex-Principal", Url: "ex-principals" },
  ];
  imageLoaded = false;
  fetchinData = true;
  ImageAlbums: any;
  GBs: any;
  GBs1: any;
  GBs2: any;
  TeacherInfo: any;
  GBms: any;
  GBms1: any;
  all_teachers_info: any[] = [];
  paginated_teachers_info: any[] = [];
  all_staff_info: any[] = [];
  paginated_staff_info: any[] = [];
  length = 0;
  pageSize = 15;
  pageIndex = 0;
  totalPages: number[] = [];
  staff: any;
  selectedItemName = "";
  private ngUnsubscribe = new Subject();
  ContentData: any;
  GBViceChairman: any;
  GBVicePrincipal: any;
  GBExPrincipal: any;
 
  constructor(
    private route: ActivatedRoute,
    private location: Location,
    private appService: AppService,
    private router: Router,
    private _changeDetectorRef: ChangeDetectorRef
  ) {}
 
  ngOnInit() {
    this.route.paramMap.subscribe((params: ParamMap) => {
      const item = params.get("item");
      const matchedItem = this.items.find((i) => i.Url === item);
      if (item && matchedItem && item == matchedItem.Url) {
        this.selectedItem = item;
        this.selectedItemName = matchedItem.Name;
      } else {
        this.selectedItem = this.items[0].Url;
        this.selectedItemName = this.items[0].Name;
        this.location.replaceState(`/${this.selectedItem}`);
      }
      this.FetchData();
    });
  }
 
  ngOnDestroy() {
    this.ngUnsubscribe.next(null);
    this.ngUnsubscribe.complete();
  }
 
  FetchData() {
    this._changeDetectorRef.markForCheck();
    this.fetchinData = true;
    if (this.selectedItem === "governing-body") {
      this.FetchGbs();
    } else if (this.selectedItem === "teacher-information") {
      this.FetchTeacherInfo();
    } else if (this.selectedItem === "ex-principals") {
      this.FetchExPrincipal();
    }  else if (this.selectedItem === "staff-information") {
      this.FetchAllStaff();
    } else {
      this.FetchGbms();
    }
  }
 
  selectItem(item: string) {
    this.selectedItem = item;
    if (this.selectedItem === "governing-body") {
      this.router.navigate([`/administration/${item}`]);
    } else if (this.selectedItem === "ex-principals") {
      this.router.navigate([`/administration/${item}`]);
 
    } else if (this.selectedItem === "vice-chairman") {
      this.router.navigate([`/administration/${item}`]);
 
    } else if (this.selectedItem === "vice-principal") {
      this.router.navigate([`/administration/${item}`]);
 
    } else if (this.selectedItem === "teacher-information") {
      this.router.navigate([`/administration/${item}`]);
    } else if (this.selectedItem === "staff-information") {
      this.router.navigate([`/administration/${item}`]);
    } else {
      this.location.go(`/administration/${item}`);
      if (this.GBms != null) {
        const matchedItem = this.items.find((i) => i.Url === item);
        this.selectedItemName = matchedItem.Name;
 
        let gm = null;
 
        if (this.selectedItem === "message-of-chairman") {
          gm = this.GBms.filter((item) => item.GBDesignationId == 4);
        } else if (this.selectedItem === "message-of-principal") {
          gm = this.GBms.filter((item) => item.GBDesignationId == 6);
        }
 
       else if (this.selectedItem === "vice-chairman") {
          gm = this.GBms.filter((item) => item.GBDesignationId == 5);
        }
 
           else if (this.selectedItem === "vice-principal") {
          gm = this.GBms.filter((item) => item.GBDesignationId == 12);
        }
 
 
 
        this.GBms1 = gm[0];
      } else {
        this._changeDetectorRef.markForCheck();
        this.fetchinData = true;
        this.FetchGbms();
      }
    }
  }
 
  onImageLoad() {
    this.imageLoaded = true;
  }
  debugger;
  FetchGbs() {
    forkJoin([this.appService.getGBs()])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((response: any) => {
        console.log(response, "response Albums");
 
        this.GBs = response[0].data.filter(
          (x) =>
            x.GBDesignation != "Ex-Principals" &&
            x.GBDesignation != "Ex-Chairmans"
        );
        console.log(this.GBs, "GB Information ");
 
        if (this.GBs) {
          let m1 = this.GBs.slice(0, 1);
          this.GBs1 = m1[0];
          this.GBs2 = this.GBs.slice(1);
        }
        // console.log(this."Main Gbs")
 
        this.fetchinData = false;
      });
  }
 
  FetchExPrincipal(){
     forkJoin([this.appService.getGBs()])
       .pipe(takeUntil(this.ngUnsubscribe))
       .subscribe((response: any) => {
         console.log(response, "response Albums");
 
         this.GBExPrincipal = response[0].data.filter(
           (x) =>
             x.GBDesignation == "Ex-Principals"
         );
         console.log(this.GBExPrincipal, "Ex-Principals ");
 
         if (this.GBs) {
           let m1 = this.GBs.slice(0, 1);
           this.GBs1 = m1[0];
           this.GBs2 = this.GBs.slice(1);
         }
         // console.log(this."Main Gbs")
 
         this.fetchinData = false;
       });
  }
 
  FetchTeacherInfo() {
    forkJoin([this.appService.getTeaherStaff()]).subscribe((response: any) => {
      console.log(response, "response Albums");
      this.ContentData = response[0].data;
      console.log(this.ContentData, "ContentData of Teacher");
      if (this.ContentData != null) {
        let all_teachers_data = this.ContentData.filter(
          (x) => x.SalarySheet == "All Teacher Salary Sheet"
        );
        this.all_teachers_info = all_teachers_data;
        console.log(this.all_teachers_info, "All teachers info");
 
        this.length = this.all_teachers_info.length;
        this.generatePageNumbers();
        this.paginateData();
      }
 
      // this.TeacherInfo = response[0].data;
      // console.log(this.TeacherInfo, "Hello All teachers");
      // let newArraay = [];
      //  Teacher
      // this.TeacherInfo.forEach((item) => {
      //   if (item.JobArena == "Academic") {
      //     newArraay.push({
      //       ...item,
      //       Items: [],
      //     });
      //   }
      // });
      // console.log(newArraay, "All Teacher");
      // this.TeacherInfo = newArraay;
      // Teacher ends
      this.fetchinData = false;
    });
  }
 
  FetchAllStaff() {
    forkJoin([this.appService.getTeaherStaff()]).subscribe((response: any) => {
      console.log(response, "response Albums");
      this.ContentData = response[0].data;
      console.log(this.ContentData, "ContentData of Staff");
      if (this.ContentData != null) {
        let all_staff_data = this.ContentData.filter(
          (x) => x.SalarySheet == "Office Staff"
        );
        this.all_staff_info = all_staff_data;
        console.log(this.all_staff_info, "All Staff info");
 
        this.length = this.all_staff_info.length;
        this.generatePageNumbers_staff();
        this.paginateData_staff();
      }
 
      // staff ends
      this.fetchinData = false;
    });
  }
 
  onPageChange(pageIndex: number) {
    this.pageIndex = pageIndex;
    this.paginateData();
  }
  onPageChange_staff(pageIndex: number) {
    this.pageIndex = pageIndex;
    this.paginateData_staff();
  }
 
  paginateData() {
    const startIndex = this.pageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.paginated_teachers_info = this.all_teachers_info.slice(
      startIndex,
      endIndex
    );
  }
  paginateData_staff() {
    const startIndex = this.pageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.paginated_staff_info = this.all_staff_info.slice(startIndex, endIndex);
  }
  generatePageNumbers() {
    const totalPageCount = Math.ceil(this.length / this.pageSize);
    this.totalPages = Array.from({ length: totalPageCount }, (_, i) => i + 1);
  }
  generatePageNumbers_staff() {
    const totalPageCount = Math.ceil(this.length / this.pageSize);
    this.totalPages = Array.from({ length: totalPageCount }, (_, i) => i + 1);
  }
 
  FetchGbms() {
    forkJoin([this.appService.getGBMessages()]).subscribe((response: any) => {
      console.log(response, "response Albums");
 
      this.GBms = response[0].data;
 
      if (this.GBms) {
        let gm = null;
 
        if (this.selectedItem === "message-of-chairman") {
          gm = this.GBms.filter((item) => item.GBDesignationId == 4);
        } else if (this.selectedItem === "message-of-principal") {
          gm = this.GBms.filter((item) => item.GBDesignationId == 6);
        } else if (this.selectedItem === "teacher-information") {
          gm = this.GBms.filter((item) => item.GBDesignationId == 6);
        } else if (this.selectedItem === "vice-chairman") {
          gm = this.GBms.filter((item) => item.GBDesignationId == 5);
        } else if (this.selectedItem === "ex-principals") {
          gm = this.GBms.filter((item) => item.GBDesignationId == 67);
        } else if (this.selectedItem === "staff-information") {
          gm = this.GBms.filter((item) => item.GBDesignationId == 4);
        }
        else if (this.selectedItem === "vice-principal") {
          gm = this.GBms.filter((item) => item.GBDesignationId == 13);
        }
        this.GBms1 = gm[0];
      }
 
      this.fetchinData = false;
    });
  }
 
  TransformUrl(value) {
    if (value.includes("https://")) {
      return value;
    } else {
      return `https://${value}`;
    }
  }
}